import { Translate, useTrans } from "@/translations";

import React, { useMemo } from "react";

import { EMPTY_DATA, EmptyDataType, emptyViewTypes } from "./emptyViewTypes";

type Props = {
  type: EmptyDataType;
  error?: Error | null;
  className?: string;
};

export const EmptyView: React.FC<Props> = ({ type, error, className }) => {
  const { t } = useTrans();

  const data = useMemo(() => emptyViewTypes[type] || EMPTY_DATA, [type]);

  return (
    <div
      className={`flex h-full flex-col items-center justify-center text-sm font-normal ${className}`}
    >
      {data.icon}
      <div className="font-medium">{t(data.label)}</div>
      {data.description && (
        <div className="text-center text-balance">
          <Translate
            i18nKey={data.description}
            components={data.descriptionComponents || []}
          />
        </div>
      )}
      {error && (
        <div className="font-dmsans text-carrot-red my-4">
          {t("errors:error")}: {error.message}
        </div>
      )}
    </div>
  );
};
